<template>
  <div class="container">
    <div class="scrollable">
      <div class="content">
        <div class="title">{{ content.title }}</div>
        <div class="sector-container">
          <router-link
            tag="div"
            class="sector"
            v-for="type in content.types"
            :key="type.name"
            :to="{
              path: './' + $route.params.content,
              query: { ps: type.name }
            }"
          >
            <img :src="imgSrc(type.icon)" />
            <span>{{ type.title }}</span>
          </router-link>
        </div>
        <div v-html="content.description"></div>
        <div>
          <a
            v-if="this.$route.params.lang === 'ES'"
            href="../../documents/Brochure LoVal Electrics Automation 2020 Esp.pdf"
            target="_blank"
            >Brochure LoVal Electrics & Automation 2020</a
          >
          <a
            v-else
            href="../../documents/Brochure LoVal Electrics Automation 2020 Eng.pdf"
            target="_blank"
            >Brochure LoVal Electrics & Automation 2020</a
          >
        </div>
      </div>
    </div>
    <LovalFooter :links="links" />
  </div>
</template>

<script>
import LovalFooter from "../LovalFooter";
export default {
  components: {
    LovalFooter
  },
  props: ["content", "links"],
  data() {
    return {};
  },
  methods: {
    imgSrc(img) {
      return require("../../assets/img/" + img);
    }
  }
};
</script>
<style lang="scss" scoped>
@import url("./style.scss");
@import url("./industries-style.scss");

a {
  color: inherit;
}
.scrollable {
  height: calc(100% - var(--loval-footer-height));
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}
.sector {
  border-radius: 20px;
  height: 40px;
  color: white;
  background-image: url(../../assets/img/NAVI-CamposLoval_Master_Home_V3.12--Recovered.png);
  display: flex;
  align-items: center;
  font-size: 130%;
  margin-bottom: 10px;
  cursor: pointer;
}
.sector img {
  height: 90%;
}
@media only screen and (min-width: 768px) {
  .scrollable {
    padding: 30px;
  }
}
@media only screen and (min-width: 1200px) {
  .content {
    padding: 20px 30px;
    background: var(--very-light-blue);
    border-top-left-radius: 30px;
    min-height: calc(100% - 40px);
  }
  .sector-container {
    display: flex;
    justify-content: space-between;
  }
  .sector {
    height: 165px;
    width: 30%;
    background-image: unset;
    flex-direction: column;
    border: 1px solid var(--dark-blue);
    background: #6da6c0;
    border-radius: unset;
    border-top-left-radius: 30px;
  }
  .sector img {
    padding: 10px;
    height: 80px;
  }
  .sector span {
    background-image: url(../../assets/img/NAVI-CamposLoval_Master_Home_V3.12--Recovered.png);
    height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
  }
}
</style>
